export const subscribeToNotification = (slug: string, type: string) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ event: "subscribeToNotification", slug, type })
    );
  }
};
